import type { ListarProdutosModel } from "../models/listarProdutosModel"
import { ListarProdutosActionsTypes, type ListarProdutosAction } from "./listarProdutosActions"

export function listarProdutosReducer(
    state: ListarProdutosModel,
    action: ListarProdutosAction
): ListarProdutosModel {
    switch (action.type) {
        case ListarProdutosActionsTypes.CARREGAR_RESULTADO:
            return { ...state, pontos: action.payload, pesquisado: true }

        case ListarProdutosActionsTypes.CARREGAR_CATEGORIAS:
            return { ...state, categorias: action.payload }

        default:
            return state
    }
}
